// ui
import { Button, Typography, Modal, Box, Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// types
import type { ReactNode } from "react";

import { useWindowSize } from "../../lib/useWindowSize";

export interface DataDeleteModalLabels {
  /** モーダルタイトル */
  title: string;
  /** 確認エリア（Alert ごと渡す。例: <Alert severity="error">〇〇後、データは復元できません。</Alert> または severity="info" の Alert） */
  confirmBody: ReactNode;
  /** 削除実行ボタンラベル */
  confirmButtonLabel: string;
  /** 成功時のメッセージ（例: "エントリーの削除に成功しました。"） */
  successMessage: string;
}

interface DataDeleteModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  deleteDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setDeleteDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  deleteData: () => void;
  /** 表示文言（呼び出し元で指定。未指定の場合は表示しない） */
  labels?: DataDeleteModalLabels;
}

export function DataDeleteModal(props: DataDeleteModalProps) {
  const {
    onModal,
    swCloseModal,
    deleteDataInf,
    setDeleteDataInf,
    deleteData,
    labels: labelsProp,
  } = props;
  const defaultLabels: DataDeleteModalLabels = {
    title: "",
    confirmBody: null,
    confirmButtonLabel: "",
    successMessage: "",
  };
  const labels: DataDeleteModalLabels = labelsProp ?? defaultLabels;
  const { title, confirmBody, confirmButtonLabel, successMessage } = labels;
  const { windowWidth } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="deleteTitleBox"
          className="shippori-antique-regular"
        >
          {title}
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {deleteDataInf.status === "open" ? (
            <>
              {confirmBody}
              <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                    textTransform: "none",
                  }}
                >
                  <Button
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                    variant="contained"
                    onClick={deleteData}
                  >
                    <Box className="m-plus-rounded-1c-regular">
                      {confirmButtonLabel}
                    </Box>
                    <DeleteIcon
                      sx={{ marginLeft: "6px", color: "white" }}
                      fontSize="medium"
                    />
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                    textTransform: "none",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : deleteDataInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">{successMessage}</Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : deleteDataInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {deleteDataInf.message}
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setDeleteDataInf({
                      ...deleteDataInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
